import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore"

const app = firebase.initializeApp({
    apiKey: "AIzaSyB9-26HUb9SwDbbc7xLukBTXJV9A3aCt84",
    authDomain: "teleportspeedtest.firebaseapp.com",
    databaseURL: "https://teleportspeedtest.firebaseio.com",
    projectId: "teleportspeedtest",
    storageBucket: "teleportspeedtest.appspot.com",
    messagingSenderId: "601654674947",
    appId: "1:601654674947:web:f9d57e7b5e80363f0b3036",
    measurementId: "G-DZ204SXV27"
});

export default app